(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/date-selector/components/name-day-by-date.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/date-selector/components/name-day-by-date.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const IconButton = svs.ui.ReactIconButton;
const Icon = svs.ui.ReactIcon;
const {
  FixedSizeList,
  areEqual
} = ReactWindow;
const {
  DATE_AND_TIME
} = svs.tickets_giftshop.constants.names;
const {
  useState,
  useRef,
  useEffect,
  useCallback,
  useMemo,
  memo
} = React;
const {
  mapMonthByNumber,
  getMonth,
  getYear,
  isLeapYear
} = svs.tickets_giftshop.gift.giftform.date_selector.components.util;
const {
  NAME_DAY_BY_DATE
} = svs.tickets_giftshop.constants.dateSelectorKey;
const DayAndNames = _ref => {
  let {
    day,
    names
  } = _ref;
  return React.createElement(React.Fragment, null, React.createElement("b", null, "".concat(day, ". ")), React.createElement("span", null, names));
};
const Row = memo(_ref2 => {
  var _items$day;
  let {
    index,
    data,
    style
  } = _ref2;
  const classNames = ['tg-name-day-by-date-row-item'];
  const {
    items,
    selectDate,
    isActive,
    isDisabled,
    month
  } = data;
  const day = Object.keys(items)[index];
  const names = (_items$day = items[day]) === null || _items$day === void 0 ? void 0 : _items$day.join(', ');
  const active = isActive(day);
  const disabled = isDisabled(day);
  if (active) {
    classNames.push('tg-name-day-by-date-selected fc-white');
  } else {
    classNames.push('fc-black');
  }
  if (disabled) {
    classNames.push('tg-name-day-by-date-disabled');
  }
  return React.createElement("div", {
    className: "tg-name-day-by-date-row",
    style: style
  }, React.createElement("a", {
    className: classNames.join(' '),
    href: "",
    onClick: e => {
      e.preventDefault();
      !disabled && selectDate(day, month);
    }
  }, React.createElement(DayAndNames, {
    day: day,
    names: names
  })));
}, areEqual);
const NameDayByDate = _ref3 => {
  let {
    date,
    dateData,
    onInputChange,
    minDate = svs.utils.date.SimpleDate(new Date()),
    maxDate = svs.utils.date.SimpleDate(new Date(new Date().setFullYear(new Date().getFullYear() + 1)))
  } = _ref3;
  const listRef = useRef(null);
  const [month, setMonth] = useState(getMonth(date));
  const [year, setYear] = useState(getYear(date));
  const formatDate = useCallback((day, month) => "".concat(year, "-").concat(month < 10 ? '0' : '').concat(month, "-").concat(day < 10 ? '0' : '').concat(day), [year]);
  const disableIncrement = formatDate(31, month) > maxDate;
  const disableDecrement = formatDate(1, month) < minDate;
  const selectDate = useCallback(function (day) {
    let m = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : month;
    const date = formatDate(day, m);
    onInputChange({
      target: {
        value: {
          date,
          time: '08:00',
          dateSelectorUsed: NAME_DAY_BY_DATE
        },
        name: DATE_AND_TIME
      }
    });
  }, [formatDate, onInputChange, month]);
  useEffect(() => {
    if (listRef.current) {
      const dayIndex = parseInt(date.split('-')[2], 10);
      listRef.current.scrollToItem(dayIndex - 1, 'center');
    }
  }, [month]);
  const updateMonth = useCallback((e, month, incrementOrDecrement) => {
    e === null || e === void 0 || e.preventDefault();
    let newMonth = month + incrementOrDecrement;
    if (newMonth > 12) {
      newMonth = 1;
      setYear(year + 1);
    }
    if (newMonth < 1) {
      newMonth = 12;
      setYear(year - 1);
    }
    if (!dateData[newMonth]) {
      updateMonth(e, newMonth, incrementOrDecrement);
    } else {
      setMonth(newMonth);
    }
  }, [dateData, year]);
  const data = useMemo(() => {
    if (!isLeapYear(year)) {
      const newFebruary = _objectSpread({}, dateData[2]);
      delete newFebruary[29];
      dateData = _objectSpread(_objectSpread({}, dateData), {}, {
        2: newFebruary
      });
    }
    return {
      itemsCount: Object.keys(dateData[month] || []).length,
      items: dateData[month] || [],
      selectDate,
      isActive: day => formatDate(day, month) === date,
      isDisabled: day => formatDate(day, month) > maxDate || formatDate(day, month) < minDate
    };
  }, [year, dateData, month, selectDate, formatDate, date, maxDate, minDate]);
  return React.createElement("div", {
    className: "tg-date-input gutter-sm-2"
  }, React.createElement("div", {
    className: "tg-name-day-by-date-pagination padding-2"
  }, React.createElement(IconButton, {
    disabled: disableDecrement,
    onClick: e => updateMonth(e, month, -1)
  }, React.createElement(Icon, {
    className: "bold",
    icon: "menu-left"
  })), React.createElement("span", {
    className: "tg-name-day-by-date-pagination-header"
  }, mapMonthByNumber(month), " ", year), React.createElement(IconButton, {
    disabled: disableIncrement,
    onClick: e => updateMonth(e, month, 1)
  }, React.createElement(Icon, {
    className: "bold",
    icon: "menu-right"
  }))), React.createElement(FixedSizeList, {
    className: "List tg-date-selector-inverted-box-shadow",
    height: 360,
    itemCount: data.itemsCount,
    itemData: data,
    itemSize: 36,
    layout: "vertical",
    ref: listRef
  }, Row));
};
svs.tickets_giftshop.gift.giftform.date_selector.components.NameDayByDate = NameDayByDate;

 })(window);